import { MainContainer } from '@/components/atoms'
import { LaunchForm } from '@/components/molecules'
import { Layout } from '@/components/templates'
import { CheckCircleIcon } from '@chakra-ui/icons'
import { Box, Heading, HStack, Text, useToast, VStack } from '@chakra-ui/react'
import emailjs from '@emailjs/browser'
import { useState } from 'react'

export const Launch = () => {
  const toast = useToast()
  const [emailSent, setEmailSent] = useState(localStorage.getItem('email_sent'))

  const onSubmit = ({ data, setIsLoading }) => {
    const emailSentInStorage = localStorage.getItem('email_sent')

    if (emailSentInStorage || emailSent) return

    emailjs
      .send(
        import.meta.env.VITE_EMAIL_SERVICE_ID,
        import.meta.env.VITE_EMAIL_TEMPLATE_ID,
        {
          email: data.email,
          reason: data.reason,
          timeframe: data.timeframe,
          website: data.website,
          message: data.message,
        },
        {
          publicKey: import.meta.env.VITE_EMAIL_PUBLIC_KEY,
        },
      )
      .then(
        (response) => {
          toast({
            status: 'success',
            title: 'Email sent successfully',
            isClosable: true,
          })
          localStorage.setItem('email_sent', true)
          setEmailSent(true)
          console.log('SUCCESS!', response.status, response.text)
          setIsLoading(false)
        },
        (err) => {
          toast({
            status: 'error',
            title: 'Email failed to send',
            isClosable: true,
          })
          console.log('FAILED...', err)
          setIsLoading(false)
        },
      )
  }

  return (
    <Layout withBackButton>
      <MainContainer>
        <HStack
          flexDirection={{ base: 'column', md: 'row' }}
          gap={8}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Box flex={1}>
            <Heading mb={10}>
              Integrate Erinaceus trust-minimized services
            </Heading>

            <VStack alignItems={'flex-start'}>
              <Heading fontWeight={600} size={'md'} mb={2}>
                Fill the form and contrct with us!
              </Heading>

              <HStack>
                <CheckCircleIcon />{' '}
                <Text>Outline your use case and product requirements.</Text>
              </HStack>
              <HStack>
                <CheckCircleIcon />{' '}
                <Text>Find the right solutions for your company</Text>
              </HStack>
              <HStack>
                <CheckCircleIcon />{' '}
                <Text>
                  Receive guidance and technical expertise integrating Erinaceus
                </Text>
              </HStack>
            </VStack>
          </Box>

          <Box
            boxShadow={'2xl'}
            maxW={450}
            flex={1}
            p={4}
            borderWidth={1}
            borderColor={'gray.100'}
            rounded={'xl'}
          >
            <LaunchForm onSubmit={onSubmit} emailSent={emailSent} />
          </Box>
        </HStack>
      </MainContainer>
    </Layout>
  )
}
